import { styled } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import MuiList from "@mui/material/List";
import CommonComponentMenuItem from "layouts/Flow Designer/components/CommonComponentMenuItem";
import commonComponents from "layouts/Flow Designer/schemas/commonComponents";
import ToolboxDetailHeader from "../ToolboxDetailHeader";
import ToolboxDetailSubHeader from "../ToolboxDetailSubHeader";
import {
  startDragComponent,
  stopDragComponent
} from "redux/actions/flowDesigner/flowsActionCreator";
import { useDetermineShareFlowUserAccessType } from "hooks/useDetermineShareFlowUserAccessType";
import useAllowEditWorkflow from "hooks/useAllowEditWorkflow";

const List = styled(MuiList)(({ theme }) => ({
  overflow: "hidden",
  overflowY: "auto",
  maxHeight: "500px",
  minHeight: "141px",
  marginRight: "12px",

  scrollbarWidth: "thin", // Firefox
  scrollbarColor: `${theme.palette.grey[400]} transparent`,

  "&::-webkit-scrollbar": {
    width: "8px",
    background: "transparent",
    transition: "opacity 0.2s",
    opacity: 0
  },
  "&:hover::-webkit-scrollbar": {
    opacity: 1
  },
  "&::-webkit-scrollbar-thumb": {
    background: theme.palette.grey[400],
    borderRadius: "8px"
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent"
  }
}));

const customStyles = {
  fontSize: "22px",
  minWidth: "40px"
};

const ComponentsList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation("flowDesigner");
  const { currentSavedFlow } = useSelector((state) => state.designer.flows);
  const { isReadOnlyAccess } = useDetermineShareFlowUserAccessType(currentSavedFlow?.id);
  const { allowEditWorkflow } = useAllowEditWorkflow();

  const onDragStart = (event, nodeType, nodeDataset) => {
    var nodeData = {
      nodeType: nodeType,
      nodeData: nodeDataset
    };
    event.dataTransfer.setData("application/reactflow", JSON.stringify(nodeData));
    event.dataTransfer.effectAllowed = "move";
    dispatch(startDragComponent());
  };

  const onDragEnd = (event) => {
    event.preventDefault();
    dispatch(stopDragComponent());
  };

  return (
    <Box
      py={2}
      pl={2}
      pr={2}
      sx={{ flexGrow: 1, height: "100%", display: "flex", flexDirection: "column" }}
    >
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 2
          //pb: 1,
        }}
      >
        <ToolboxDetailHeader title={t("toolbox.headers.components")} />
        <ToolboxDetailSubHeader
          title={t("toolbox.titles.library")}
          subtitle={t("toolbox.subtitles.library_components")}
        />
      </Box>
      <List
        sx={{
          width: 290,
          height: 500,
          maxHeight: 500,
          minHeight: 141,
          overflowY: "auto",
          overflowX: "hidden"
        }}
      >
        {commonComponents
          ?.sortAlphabetical("label")
          .filter((component) => component.type !== "executionReportComponent")
          .map((comp) => (
            <CommonComponentMenuItem
              key={comp.type}
              label={comp.label}
              type={comp.type}
              icon={comp.icon}
              customStyles={customStyles}
              onDragStart={onDragStart}
              onDragEnd={onDragEnd}
              allowDescription
              allowDragAndDrop
              allowEditWorkflow={allowEditWorkflow(isReadOnlyAccess)}
            />
          ))}
      </List>
    </Box>
  );
};

export default ComponentsList;
